import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, image, url }) => {
  return (
    <Helmet>
      <title>{title || 'Pacified® App: Making Parent’s Life Easier'}</title>
      <meta 
        name="description" 
        content={
          description ||
          'A scientific approach to choosing the right pacifier for your little one! Avoid guesswork and costly dental issues with right-sized biometric pacifiers.'
        } 
      />
      <meta 
        name="keywords" 
        content={
          keywords || 'Pacified, pacified, pacifier, biometric, dental health, parenting, baby care, orthodontics, science-based'
        } 
      />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta property="og:title" content={title || 'Pacified® App: Making Parent’s Life Easier'} />
      <meta 
        property="og:description" 
        content={
          description ||
          'Discover how the Pacified® App offers a scientific approach to find the best fitting pacifier for your baby. Avoid guesswork and costly dental issues with right-sized biometric pacifiers.'
        } 
      />
      <meta property="og:url" content={url || window.location.href} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default SEO;
